// src/hooks/useHoverSound.js
import { useEffect } from "react";
import { Howl } from "howler";

function useHover(soundFile = "assets/sounds/hover.wav", volume = 0.5) {
  useEffect(() => {
    const hoverSound = new Howl({ src: [soundFile], volume });

    // Select all buttons
    const buttons = document.querySelectorAll("button");
    const links = document.querySelectorAll("a");

    const handleHover = () => hoverSound.play();

    // Add hover sound listener to all buttons
    buttons.forEach((btn) => btn.addEventListener("mouseenter", handleHover));
    links.forEach((a) => a.addEventListener("mouseenter", handleHover));

    // Cleanup
    return () => {
      buttons.forEach((btn) => btn.removeEventListener("mouseenter", handleHover));
      links.forEach((a) => a.removeEventListener("mouseenter", handleHover));
    };
  }, [soundFile, volume]);
}

export default useHover